/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const Member = zod
	.object({
		email: zod.email().describe('User email'),
		id: zod.string().describe('User ID'),
		joined_at: zod.iso.datetime({ offset: true }).describe('When the user joined'),
		role: zod.enum(['owner', 'member'])
	})
	.describe('Organization member');

export type Member = zod.input<typeof Member>;
export type MemberOutput = zod.output<typeof Member>;
